'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Input = require('../../../inputs/Input');

var _Input2 = _interopRequireDefault(_Input);

var _Checkbox = require('../../../inputs/Checkbox');

var _Checkbox2 = _interopRequireDefault(_Checkbox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function TextCondition(props) {
  var linkState = props.linkState,
      style = props.style;


  return _react2.default.createElement(
    'div',
    { className: style.searchWidget },
    _react2.default.createElement(
      'div',
      { style: { width: 500, display: 'inline-block', marginRight: 10 } },
      _react2.default.createElement(_Input2.default, linkState('text'))
    ),
    _react2.default.createElement(_Checkbox2.default, _extends({ label: '\u5B8C\u5168\u76F8\u7B26' }, linkState('fullMatch')))
  );
}

var object = _propTypes2.default.object,
    func = _propTypes2.default.func;

TextCondition.propTypes = {
  linkState: func.isRequired,
  style: object.isRequired
};

TextCondition.buildQuery = function buildTextQuery(_ref) {
  var text = _ref.text,
      fullMatch = _ref.fullMatch;

  if (!text) return null;

  return fullMatch ? { $eq: '' + text } : { $regex: '' + text, $options: 'i' };
};

exports.default = TextCondition;


//////////////////
// WEBPACK FOOTER
// ./~/coact/components/DocList/QueryEditor/ConditionEditor/TextCondition.js
// module id = 1722
// module chunks = 0